import { defineMessages } from 'react-intl';

import CREDIT_SCORES from '../definitions/CreditScores';


const MESSAGES = defineMessages({
    [CREDIT_SCORES.EXCELLENT]: {
        id: 'base-ui.credit-score.excellent',
        defaultMessage: 'Excellent (760+)',
    },
    [CREDIT_SCORES.VERY_GOOD]: {
        id: 'base-ui.credit-score.very-good',
        defaultMessage: 'Very Good (725\u2011759)',     // non-breaking hyphen; use of {nbhy} used to break dropdowns
    },
    [CREDIT_SCORES.GOOD]: {
        id: 'base-ui.credit-score.good',
        defaultMessage: 'Good (660\u2011724)',
    },
    [CREDIT_SCORES.FAIR]: {
        id: 'base-ui.credit-score.fair',
        defaultMessage: 'Fair (560\u2011659)',
    },
    [CREDIT_SCORES.POOR]: {
        id: 'base-ui.credit-score.poor',
        defaultMessage: 'Poor (below\u00A0560)',     // non-breaking space; use of {nbsp} used to break dropdowns
    },
    [CREDIT_SCORES.NONE]: {
        id: 'base-ui.credit-score.none',
        defaultMessage: 'I don’t know it',
    },
});

const CREDIT_SCORES_OPTIONS = Object.values(CREDIT_SCORES).map(value => ({
    value: value,
    label: MESSAGES[value],
}));


export default CREDIT_SCORES_OPTIONS;
